import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { TThunkDispatch } from '../../types/redux';
import { LoadMoreButton } from '../../components/LoadMoreButton';
import { fetchConstructionProgress } from '../../actions/constructionProgressData';
import { trackTotalMorePhotosClick } from '../../utils/analytics';
import {
  selectConstructionProgressLast,
  selectConstructionProgressLoading,
} from '../../selectors/constructionProgress';

export const LoadMoreButtonContainer: React.FC = () => {
  const loading = useSelector(selectConstructionProgressLoading);
  const last = useSelector(selectConstructionProgressLast);
  const dispatch: TThunkDispatch = useDispatch();

  const handleClick = React.useCallback(() => {
    dispatch(fetchConstructionProgress());
    trackTotalMorePhotosClick();
  }, [dispatch]);

  if (last) {
    return null;
  }

  return <LoadMoreButton loading={loading} onClick={handleClick} />;
};
